import { useCallback } from 'react';
import type { List } from '@gonfalon/immutable-shim/immutableShim';

import { useDispatch } from '#hooks/useDispatch';
import type { Rollout } from '#utils/flags/records/Rollout';
import type { Variation } from '#utils/flags/records/Variation';
import type { SemanticInstructionRolloutWeights } from '#utils/instructions/rules/types';
import type { PendingChangesFormValueType } from '#utils/pendingChanges/types';
import type { GenerateActionType } from '#utils/reduxUtils';

export const editPendingChangesForm = (field: string, value: PendingChangesFormValueType) =>
  ({
    type: 'pendingChanges/EDIT_PENDING_CHANGES_FORM',
    field,
    value,
  }) as const;

export function useEditPendingChangesFormAction() {
  const dispatch = useDispatch();

  return useCallback(
    (field: string, value: PendingChangesFormValueType) => {
      dispatch(editPendingChangesForm(field, value));
    },
    [dispatch],
  );
}

export function getFallthroughRollout(rollout: Rollout, variations: List<Variation>) {
  const weights: SemanticInstructionRolloutWeights = {};
  rollout.get('variations').forEach((variation) => {
    const index = variation.get('variation');
    const id = variations.get(index)?._id;
    if (id) {
      weights[id] = variation.get('weight');
    }
  });

  return {
    experimentAllocation: rollout.get('experimentAllocation'),
    bucketBy: rollout.get('bucketBy'),
    contextKind: rollout.get('contextKind'),
    weights,
  };
}

const PendingChangesFormActionCreators = {
  editPendingChangesForm,
};

export type PendingChangesAction = GenerateActionType<typeof PendingChangesFormActionCreators>;
